import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./UserProfile.module.css";

function UserProfile() {
  const navigate = useNavigate();

  
  const [user, setUser] = useState({
    name: "Richa Sharma",
    email: "richasharma@gmail.com",
    image: "/assets/images/content.png",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState(user);

  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  
  const handleSave = () => {
    setUser(formData);
    setIsEditing(false);
  };

  
  const handleLogout = () => {
    
    navigate("/login");
  };

  return (
    <div className={style.main_wrapper}>
      <div className={style.banner}>
        <h1 className={style.title}>My Profile</h1>
      </div>

      <div className={style.profile_section}>
        <div className={style.card}>
          <img
            src={user.image}
            alt="profile"
            className={style.profile_img}
          />

          {isEditing ? (
            <>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={style.input}
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={style.input}
              />

              <button onClick={handleSave} className={style.save_btn}>
                Save
              </button>
            </>
          ) : (
            <>
              <h2 className={style.user_name}>{user.name}</h2>
              <p className={style.user_email}>{user.email}</p>

              <button
                onClick={() => setIsEditing(true)}
                className={style.update_btn}
              >
                Edit Profile
              </button>
            </>
          )}

          <button onClick={handleLogout} className={style.logout_btn}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
